import { useEffect, useRef, useState } from "react"
import { useSnapshot } from "valtio"
import { AgmodalStore, bookingsStore, configStore, fclChargesStore, quoteDataRec } from "../state/CommonState"
import Utils from "../util/Utils"
import Api from "../state/Api"
import { commodityList, hazardousList, ServerLists } from "../StaticData"
import airlineCodes from "../static-data/airlines"
import { taskStore } from "../mytasks/task-store"
import { myactionsstore } from "../my-actions/store-myactions"
import { enquiryStore } from "../enquiry/enquiry-data"



const $c = (props) => {
    const classname = `column is-${props.n}`
    return (
        <div className={classname} {...props}>{props.children}</div>
    )
}
const $cr = (props) => {
    const classname = `column is-${props.n} is-small`
    return (
        <div style={{ textAlign: 'right', paddingRight: '1rem' }} className={classname} {...props}>{props.children}</div>
    )
}
const $cg = (props) => {
    const classname = `column is-${props.n} is-small`
    return (
        <div style={{ backgroundColor: 'white', border: '1px solid #efefef' }} className={classname} {...props}>{props.children}</div>
    )
}
export {
    $c,
    $cg,
    $cr
}

export function TableEdit(props) {
    const { record, parent, name, type = 'text', tabIndex = '0', isreadonly = false, callback = f => f, isValid = true, isDisabled ,isblue=false,} = props
    const imRecord = useSnapshot(record)
    const [val,setVal] = useState(parent ? parent[name] : imRecord[name])
    //console.log(name, record[name], record,  'record[name]chekkkkkkkkkkkkkkk');
    const handleInputChange = (e) => {
        if(!isblue){
            const newValue = e.target.value
            if (parent) parent[name] = newValue
            else record[name] = newValue; // Update the Valtio state
            if (props.makezero) {
                let key = props.makezero
                if (parent) parent[key] = 0
                else record[key] = 0
            }
            setVal(newValue)
            callback(newValue);
        }else{
            setVal(e.target.value)
        }
    };
    return (
        <div className="control is-fullwidth is-small">
            <input
                style={{ color: 'black' }}
                {...props}
                type={type}
                name={name}
                value={val}
                // onKeyDown={(e) =>
                //     ["e", "E", "+"].includes(e.key) && e.preventDefault()
                // }
                onBlur={(e)=>{
                    if(isblue){
                        callback(e.target.value)
                    }
                }}
                onChange={handleInputChange}
                className={isValid ? "input is-small" : "input is-small is-danger"}
                inputmode={type}
                {...isDisabled}
                readOnly={isreadonly}
            />
        </div>
    )
}

export function EditableInput(props) {
    useSnapshot(configStore)
    const { record, name, type = 'text', tabIndex = '0', isreadonly = false, callback = f => f, isValid = true, isDisabled } = props
    const [value, setValue] = useState("");
    const imRecord = useSnapshot(record)

    const handleChange = (e) => {
        setValue(e.target.value);
        record[name] = value; // Update the Valtio state
        callback(value);
    };

    return (
        <div className="control is-fullwidth is-small">
            <input
                type="text"
                value={value}
                onChange={handleChange}
                className={`input is-small ${isValid ? '' : 'is-danger'}`}
            />
        </div>
    );
}
export function TableEditCharges(props) {
    useSnapshot(configStore)
    const { record, name, type, isreadonly = false, callback = f => f, isValid = true, isDisabled } = props;
    const imRecord = useSnapshot(record);
    const [val, setVal] = useState(imRecord[name] || ''); // Initialize with the value from imRecord if available

    useEffect(() => {
        setVal(imRecord[name] || ''); 
    }, [imRecord, name]);

    const handleInputChange = (e) => {
        setVal(e.target.value);
    };

    const handleBlur = () => {
        record[name] = val;
    };

    return (
        <div className="control is-fullwidth is-small">
            <input
                style={{ color: 'black' }}
                {...props}
                type={type}
                {...props}
                name={name}
                value={val}
                onChange={handleInputChange}
                onBlur={handleBlur}
                className={isValid ? "input is-small" : "input is-small is-danger"}
                {...isDisabled}
                readOnly={isreadonly}
            />
        </div>
    );
}


export function TableLabel({ record, name }) {
    return (
        <div className="control is-fullwidth">
            <input name={name} defaultValue={record[name]} disabled={true}
                className="input is-small" />
        </div>
    )
}
export function TableSelect(props) {
    useSnapshot(configStore)
    const { record, name, dataList, tabIndex = 0, callback = f => f, isValid = true, isDisabled } = props
    const imRecord = useSnapshot(record)
    let isonaccountvalid = true
    if(name == "currency" && record[name] != undefined && record[name].trim().length>0){
        let a = configStore.getExchangeRate(record[name])
        if(record["currencyinr"] != a){
            record["currencyinr"] = a
        }
    }
    if(name=="onaccount" && isValid==false){
        isonaccountvalid = true
    }else{
        isonaccountvalid = isValid
    }
    if(name === 'onaccount' && (record[name] === undefined || record[name].trim().length==0)){
        record[name] = 'On Your Account'
    }

    //console.log("props-------------->",props,record[name])
    // const packageTypeList = ['', 'Pallet', 'Drum', 'Crate', 'Skid', 'Loose Cartons', 'Box', 'Bales', 'Rolls']
    return (
        <div className={isValid || isonaccountvalid ? "select is-small" : "select is-small is-danger"} >
            <select style={{ color: 'black' }} {...props} tabIndex={tabIndex} name={name}
                value={imRecord[name]} onChange={(e) => {
                    record[name] = e.target.value
                    if(name === 'containerType'){
                        fclChargesStore.defaultValueCalc() // Need to calculate for validation
                    }
                    callback(e.target.value)
                }}
                {...isDisabled}>
                <option selected={!isDisabled} value={''} hidden>
                    {''}
                </option>
                {dataList.filter(val => val !== '').map(val => <option selected={val === record[name]} key={val}>{val}</option>)}
            </select>
        </div>
    )
}
export function TableSelect7(props) {
    const { record, name, dataList, tabIndex = 0, callback = f => f, isValid = true, isDisabled } = props
    const imRecord = useSnapshot(record)
    // console.log(">>>>",record[name])
    // const packageTypeList = ['', 'Pallet', 'Drum', 'Crate', 'Skid', 'Loose Cartons', 'Box', 'Bales', 'Rolls']
    if(record[name] == undefined || record[name] == 'CBM'){
        // record[name] == 'CBM'
        configStore.updateUnitDropdown = 'CBM'
    }else{
        // record[name] == 'cu ft'
        configStore.updateUnitDropdown = 'cu ft'

    }
    return (
        <div className={isValid ? "select is-small" : "select is-small is-danger"} >
            <select style={{ color: 'black' }} {...props} tabIndex={tabIndex} name={name}
                value={record[name]} onChange={(e) => {
                    record[name] = e.target.value
                    if(name === 'containerType'){
                        fclChargesStore.defaultValueCalc() // Need to calculate for validation
                    }
                    callback(e.target.value)
                }}
                {...isDisabled}>
                {/* <option selected={!isDisabled} value={''} hidden>
                    {''}
                </option> */}
                {dataList.filter(val => val !== '').map(val => <option selected={val === record[name]} key={val}>{val}</option>)}
            </select>
        </div>
    )
}
export function TableSelect1(props) {
    const { record, name, dataList, tabIndex = 0, callback = f => f, isValid = true, isDisabled } = props
    const imRecord = useSnapshot(record)
    useSnapshot(taskStore)
    // const packageTypeList = ['', 'Pallet', 'Drum', 'Crate', 'Skid', 'Loose Cartons', 'Box', 'Bales', 'Rolls']
    return (
        <div
            className={`input is-small ${(!taskStore.current.isValid && taskStore.current.isValidfield.indexOf(name) != -1) ? "is-danger" : ""} `}
        >
            <select style={{ backgroundColor: 'white', color: 'black' }} {...props} tabIndex={tabIndex} name={name}
                // className={`input is-small ${ (!taskStore.current.isValid && taskStore.current.isValidfield.indexOf(name) != -1)  ? "is-danger" : ""} `}
                value={imRecord[name]} onChange={(e) => {
                    record[name] = e.target.value
                    callback(e.target.value)
                }}
                {...isDisabled}>
                <option selected value={''} hidden>
                    {''}
                </option>
                {dataList.filter(val => val !== '').map(val => <option key={val}>{val}</option>)}
            </select>
        </div>
    )
}
export function TableSelect5(props) {
    const { record, name, label, dataList, tabIndex = 0, callback = f => f, isValid = true, isDisabled } = props
    return (
        <>
            <div className="columns">
                <div className="column is-6 py-2">
                    <div style={{ marginRight: '5px', marginTop: '3px', fontWeight: "bold" }}>{label}</div>
                </div>
                <div className="column is-6 py-2">
                    <select style={{ backgroundColor: 'white', color: 'black', width: "20em" }} disabled={isDisabled} {...props} tabIndex={tabIndex} name={name}
                        value={record[name]} onChange={(e) => {
                            record[name] = e.target.value
                            callback(e.target.value)
                        }}
                        >
                        <option selected value={''} hidden>
                            {''}
                        </option>{
                            (dataList) ? dataList.map(({ key, value }) => (
                                <option value={value}>{key}</option>
                            )) : ""
                        }
                    </select>

                </div>
            </div>
        </>
    )
}
export function AgSelect(props) {
    const { label, record, name, dataList, callback = f => f, isValid = true, validationMsg, isDisabled } = props
    const imRecord = useSnapshot(record)
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control">
                <div className={isValid ? "select is-small" : "select is-small is-danger"}>
                    <select {...props} name={name} value={imRecord[name]}
                        {...isDisabled}
                        onChange={(e) => {
                            if(name === 'shipmentScope'){
                                quoteDataRec.origin = ""
                                quoteDataRec.destination = ""
                            }
                            console.log('FROM INSIDE AgSelect=', e.target.value)
                            record[name] = e.target.value
                            callback(e.target.value)

                        }} >
                        <option selected value={''} hidden>
                            {''}
                        </option>
                        {dataList.filter(val => val !== '').map(val => <option key={val}>{val}</option>)}
                    </select>
                </div>
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please select valid ${label}`}</p>}
        </div>
    )
}
export function AgSelectCA(props) {
    const { label, name, dataList, callback = f => f, isValid = true, validationMsg, isDisabled, value } = props
    const [val, setVal] = useState(value)
    return (
        <div className="field">
            <label className="label is-small">{label}</label>
            <div className="control">
                <div className={isValid ? "select is-small" : "select is-small is-danger"}>
                    <select {...props} name={name} value={val}
                        {...isDisabled}
                        onChange={(e) => {
                            console.log('FROM INSIDE AgSelect=', e.target.value)
                            setVal(e.target.value)
                            callback(e.target.value)

                        }} >
                        <option selected value={''} hidden>
                            {''}
                        </option>
                        {dataList.filter(val => val !== '').map(val => <option key={val}>{val}</option>)}
                    </select>
                </div>
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please select valid ${label}`}</p>}
        </div>
    )
}
export function AgSelectCountry(props) {
    const { label, record, name, dataList, callback = f => f, isValid = true, validationMsg, isDisabled } = props
    useSnapshot(enquiryStore)

    if(enquiryStore.current.countryFromEnquiry == undefined){
        enquiryStore.current.countryFromEnquiry =  "India"
    }
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control">
                <div className={isValid ? "select is-small" : "select is-small is-danger"}>
                    <select {...props} name={name} value={enquiryStore.current.countryFromEnquiry}
                        {...isDisabled}
                        onChange={(e) => {
                            console.log('FROM INSIDE AgSelect=', e.target.value)
                            enquiryStore.current.countryFromEnquiry = e.target.value
                            callback(e.target.value)

                        }} >
                        {dataList.filter(val => val !== '').map(val => <option key={val}>{val}</option>)}
                    </select>
                </div>
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please select valid ${label}`}</p>}
        </div>
    )
}
export function AgSelect1(props) {
    const { label, record, name, dataList, callback = f => f, isValid = true, validationMsg, isDisabled } = props
    const imRecord = useSnapshot(record)
    //console.log("check name------->", name, imRecord[name])
    //console.log("output", name === 'onaccount' ? imRecord[name] === undefined ? dataList[0] : "On Your Account"  : imRecord[name])
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control">
                <div className={isValid ? "select is-small" : "select is-small is-danger"}>
                    <select {...props} name={name} value={imRecord[name]}
                        {...isDisabled}
                        onChange={(e) => {
                            //console.log('FROM INSIDE AgSelect=', record, e.target.value)
                            record[name] = e.target.value
                            callback(e.target.value)
                        }} >
                        <option selected value={''} hidden>
                            {''}
                        </option>
                        {
                            Object.entries(dataList).map(([key, value]) => (
                                <option value={value}>{key}</option>
                            ))
                        }
                    </select>
                </div>
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please select valid ${label}`}</p>}
        </div>
    )
}
export function AgAirline({ label, record, name, callback = f => f, isValid = true, validationMsg }) {
    const imRecord = useSnapshot(record)
    if(imRecord[name]?.length>0 && imRecord[name].indexOf('(') != -1 && imRecord[name].indexOf(')') != -1){
        record[name] = imRecord[name].trim().slice(imRecord[name].lastIndexOf("(") + 1, imRecord[name].length - 1)
    }
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control">
                <div className={isValid ? "select is-small" : "select is-small is-danger"}>
                    <select name={name} value={imRecord[name]}
                        onChange={(e) => {
                            record[name] = e.target.value
                            callback(e.target.value)
                        }} >
                        <option value=''></option>
                        {airlineCodes.map(val => <option value={val.code}>{val.name}</option>)}
                    </select>
                </div>
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please select valid ${label}`}</p>}
        </div>
    )
}
export function AgInput(props) {

    const { placeholder, label, record, name, type = 'text', validate = f => f, callback = f => f, isValid = true, validationMsg } = props
    let { id,isDisabled } = props
    const imRecord = useSnapshot(record)
    const [cursor, setCursor] = useState(0)
    if(id==undefined){
        id=name
    }
    let min = ''
    let max = '2120-01-01'
    if (type === 'date') {
        min = Utils.getCurrentDateString()
        if (label == '* Valid Upto') {
            if (record['cargoReadinessDate']?.length == 0) {
                isDisabled = { disabled: true }
            }
            min = record['cargoReadinessDate']
            //max = Utils.getMaxDateString(record['cargoReadinessDate'])
        }
        // else{
        //     max = '2120-01-01'
        // }



    }
    function trimStr(str) {
        if (!str) return str;
        return str.replace(/^\s+/g, '');
    }

    const handleChange = (e, name) => {



        setCursor(e.target.selectionStart)
        if (name == 'origin' || name == 'destination') {
            record[name] = trimStr(e.target.value)
        } else if (name === 'firstName' || name === 'lastName' || name=="lable") {
            record[name] = e.target.value
        } else {
            record[name] = e.target.value.trim()
        }
        if (name === 'cargoReadinessDate') {
            record['validUpto'] = ''
        }
        // record[r] = trimStr(e.target.value)    

        if (props.handleChange) {
            //console.log(props.handleChange, "testtest", e.target.value);
            props.handleChange[name] = e.target.value.trim() === '';
            //console.log(props.handleChange, "testtest1");
        }

    }


    let align = {}
    if (type === 'number') align = { align: 'right' }
    if (type === 'text') align = { align: 'right' }
    return (
        <div className="field">

            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                {
                    (name === 'customerReferenceNum') ? <input style={{ ...align, borderColor: props.isInvalid ? 'red' : '' }} {...props} id={id} name={id} value={imRecord[name]} onChange={(e) => {
                        // record[name] = e.target.value

                        handleChange(e, name)
                        callback(e.target.value)
                        console.log(e.target.value, "check1");
                        // props.handleChange(e)
                    }}
                        onInput={(e) => {
                            if (name == 'cargoValue') {
                                console.log('testing');
                                e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5);
                            }
                        }}
                        onKeyDown={(e) => {
                            if (type !== 'text') {
                                return ["e", "E", "+"].includes(e.key) && e.preventDefault()
                            }
                        }

                        }
                        {...isDisabled}
                        className={isValid ? "input is-small" : "input is-small is-danger"}
                        type={type} min={min} max={max} onFocus={(e) => {
                            document.getElementById(id).showPicker()
                        }}
                        placeholder={placeholder==undefined?label:placeholder} onBlur={(e) => {
                            validate(e.target.value)
                        }} /> : <input style={{ ...align, borderColor: props.isInvalid ? 'red' : '' }} {...props} id={id} name={id} value={imRecord[name]}
                            onInput={(e) => {
                                if (name == 'cargoValue') {
                                    console.log('testing');
                                    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5);
                                }
                            }}

                            onChange={(e) => {
                                record[name] = e.target.value
                                callback(e.target.value)
                                console.log(e.target.value, "check2");
                                handleChange(e, name)
                                // props.handleChange(e)
                            }}
                            onKeyDown={(e) => {
                                if (type === 'date') {
                                    e.preventDefault(); // Prevent any typing in date fields
                                } else if (type !== 'text') {
                                    return ["e", "E", "+"].includes(e.key) && e.preventDefault()
                                }
                            }
                            }

                            {...isDisabled}
                            className={isValid ? "input is-small" : "input is-small is-danger"}
                            type={type} min={min} max={max} onFocus={(e) => {
                                document.getElementById(id).showPicker()
                            }}
                            maxLength={30}
                            placeholder={placeholder==undefined?label:placeholder} onBlur={(e) => {
                                validate(e.target.value)
                            }} />
                }

            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please enter valid ${label}`}</p>}
        </div>
    )
}

export function AgInputForAlphaNumeric(props) {

    const { placeholder, label, record, name, type = 'text', validate = f => f, callback = f => f, isValid = true, validationMsg } = props
    let { isDisabled } = props
    const imRecord = useSnapshot(record)
    const [cursor, setCursor] = useState(0)

    let min = ''
    let max = '2120-01-01'
    if (type === 'date') {
        min = Utils.getCurrentDateString()
        if (label == '* Valid Upto') {
            if (record['cargoReadinessDate'].length == 0) {
                isDisabled = { disabled: true }
            }
            min = record['cargoReadinessDate']
            //max = Utils.getMaxDateString(record['cargoReadinessDate'])
        }
        // else{
        //     max = '2120-01-01'
        // }



    }
    function trimStr(str) {
        if (!str) return str;
        return str.replace(/^\s+/g, '');
    }

    const handleChange = (e, name) => {



        setCursor(e.target.selectionStart)
        if (name == 'origin' || name == 'destination') {
            record[name] = trimStr(e.target.value.replace(/[^a-zA-Z0-9 ]/g, ''))
        } else if (name === 'firstName' || name === 'lastName' || name=="lable") {
            record[name] = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '')
        } else {
            record[name] = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '').trim()
        }
        if (name === 'cargoReadinessDate') {
            record['validUpto'] = ''
        }
        // record[r] = trimStr(e.target.value)    

        if (props.handleChange) {
            //console.log(props.handleChange, "testtest", e.target.value);
            props.handleChange[name] = e.target.value.replace(/[^a-zA-Z0-9 ]/g, '').trim() === '';
            //console.log(props.handleChange, "testtest1");
        }

    }


    let align = {}
    if (type === 'number') align = { align: 'right' }
    if (type === 'text') align = { align: 'right' }
    return (
        <div className="field">

            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                {
                    (name === 'customerReferenceNum') ? <input style={{ ...align, borderColor: props.isInvalid ? 'red' : '' }} {...props} id={name} name={name} value={imRecord[name]} onChange={(e) => {
                        // record[name] = e.target.value

                        handleChange(e, name)
                        callback(e.target.value)
                        console.log(e.target.value, "check1");
                        // props.handleChange(e)
                    }}
                        onInput={(e) => {
                            if (name == 'cargoValue') {
                                console.log('testing');
                                e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5);
                            }
                        }}
                        onKeyDown={(e) => {
                            if (type !== 'text') {
                                return ["e", "E", "+"].includes(e.key) && e.preventDefault()
                            }
                        }

                        }
                        {...isDisabled}
                        className={isValid ? "input is-small" : "input is-small is-danger"}
                        type={type} min={min} max={max} onFocus={(e) => {
                            document.getElementById(name).showPicker()
                        }}
                        placeholder={label} onBlur={(e) => {
                            validate(e.target.value)
                        }} /> : <input style={{ ...align, borderColor: props.isInvalid ? 'red' : '' }} {...props} id={name} name={name} value={imRecord[name]}
                            onInput={(e) => {
                                if (name == 'cargoValue') {
                                    console.log('testing');
                                    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5);
                                }
                            }}

                            onChange={(e) => {
                                record[name] = e.target.value
                                callback(e.target.value)
                                console.log(e.target.value, "check2");
                                handleChange(e, name)
                                // props.handleChange(e)
                            }}
                            onKeyDown={(e) => {
                                if (type === 'date') {
                                    e.preventDefault(); // Prevent any typing in date fields
                                } else if (type !== 'text') {
                                    return ["e", "E", "+"].includes(e.key) && e.preventDefault()
                                }
                            }
                            }

                            {...isDisabled}
                            className={isValid ? "input is-small" : "input is-small is-danger"}
                            type={type} min={min} max={max} onFocus={(e) => {
                                document.getElementById(name).showPicker()
                            }}
                            maxLength={30}
                            placeholder={placeholder} onBlur={(e) => {
                                validate(e.target.value)
                            }} />
                }

            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please enter valid ${label}`}</p>}
        </div>
    )
}


export function AgReportInput(props) {
    const { label, record, name, type = 'text', validate = f => f, callback = f => f, isValid = true, validationMsg } = props
    let { isDisabled } = props
    const imRecord = useSnapshot(record)
    let min = ''
    let max = ''
    if (type === 'date') {
        max = Utils.getCurrentDateString()
        //max = Utils.getMaxDateString
    }
    let align = {}
    if (type === 'number') align = { align: 'right' }
    if (type === 'text') align = { align: 'right' }
    return (
        <div className="field">

            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                <input style={{ ...align }} {...props} id={name} name={name} value={imRecord[name]} onChange={(e) => {
                    record[name] = e.target.value
                    callback(e.target.value)
                }}
                    {...isDisabled}
                    className={isValid ? "input is-small" : "input is-small is-danger"}
                    type={type} min={min} max={max} onFocus={(e) => {
                        document.getElementById(name).showPicker()
                    }}
                    placeholder={label} onBlur={(e) => {
                        validate(e.target.value)
                    }} />
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please enter valid ${label}`}</p>}
        </div>
    )
}


export function AgVehicletInput(props) {
    const { label, record, name, type = 'text', validate = f => f, callback = f => f, isValid = true, validationMsg } = props
    let { isDisabled } = props
    const imRecord = useSnapshot(record)
    let min = ''
    let max = ''
    if (type === 'date') {
        //   max = Utils.getCurrentDateString() 
        max = Utils.getMaxDateString
    }
    let align = {}
    if (type === 'number') align = { align: 'right' }
    if (type === 'text') align = { align: 'right' }
    return (
        <div className="field">

            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                <input style={{ ...align }} {...props} id={name} name={name} value={imRecord[name]} onChange={(e) => {
                    record[name] = e.target.value
                    callback(e.target.value)
                }}
                    {...isDisabled}
                    className={isValid ? "input is-small" : "input is-small is-danger"}
                    type={type} min={min} max={max} onFocus={(e) => {
                        document.getElementById(name).showPicker()
                    }}
                    placeholder={label} onBlur={(e) => {
                        validate(e.target.value)
                    }} />
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please enter valid ${label}`}</p>}
        </div>
    )
}
export function AgPhoneNew({ label, record, name, type = 'text', validate = f => f }) {
    const imRecord = useSnapshot(record)
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                <div style={{ display: 'flex', alignItems: 'center', fontSize: '0.8rem' }}>
                    <span style={{ paddingRight: '3px' }}><strong>{record['phonePrefix']}</strong></span>
                    <input id={name} name={name} value={imRecord[name]} onChange={(e) => record[name] = e.target.value}
                        className="input is-small"
                        onKeyDown={(e) =>
                            ["e", "E", "+"].includes(e.key) && e.preventDefault()
                        }
                        onInput={(e) => {
                            e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
                        }}
                        type={type}
                        placeholder={label} onBlur={(e) => {
                            validate(e.target.value)
                        }} />

                </div>
            </div>
        </div>
    )
}
export function AgDisplay({ label, value }) {
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth" style={{ color: '#004433', fontSize: '0.85rem' }}>
                {value}
            </div>
        </div>
    )
}
export function Agpassword(props) {
    const [ptype, setptype] = useState('password')
    const [icon, setIcon] = useState('fas fa-eye-slash')
    let callback = props.callback
    if (!callback) callback = f => f
    let txtPassword = useRef()

    if (props.myref) {
        console.log('props has ref')
        txtPassword = props.myref
    }
    let label = 'Password'
    if (props.label) label = props.label
    return (
        <div className="field">
            <label className="label">{label}</label>
            <div className='field has-addons' style={{ justifyContent: 'stretch', flexGrow: 1 }}>
                <div className="control" style={{ width: '90%' }}>
                    <input className="input" type={ptype} defaultValue={props.value}
                        ref={txtPassword} placeholder="********" required />
                </div>
                <div class="control">
                    <button type="button" class="button is-flat" onClick={(e) => {
                        e.preventDefault()
                        if (ptype === 'password') {
                            setptype('text')
                            setIcon('fas fa-eye')
                        } else {
                            setptype('password')
                            setIcon('fas fa-eye-slash')
                        }
                    }}>
                        <span className="icon is-small">
                            <i className={icon}></i>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    )
}
export function AgpasswordSmall(props) {
    const [ptype, setptype] = useState('password')
    const [icon, setIcon] = useState('fas fa-eye-slash')
    let callback = props.callback
    if (!callback) callback = f => f
    let txtPassword = useRef()

    if (props.myref) {
        txtPassword = props.myref
    }
    let label = 'Password'
    if (props.label) label = props.label
    return (
        <div className="field">
            <label className="label is-small">{label}</label>
            <div className='field has-addons' style={{ justifyContent: 'stretch', flexGrow: 1 }}>
                <div className="control" style={{ width: '90%' }}>
                    <input className="input is-small" type={ptype} defaultValue={props.value}
                        ref={txtPassword} placeholder="********" required />
                </div>
                <div class="control">
                    <button type="button" class="button is-flat is-small" onClick={(e) => {
                        e.preventDefault()
                        if (ptype === 'password') {
                            setptype('text')
                            setIcon('fas fa-eye')
                        } else {
                            setptype('password')
                            setIcon('fas fa-eye-slash')
                        }
                    }}>
                        <span className="icon is-small">
                            <i className={icon}></i>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    )
}
export function AgNumber({ label, isValid,value, callback = f => f,validationMsg }) {
    const [val, setVal] = useState(value)
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                <input value={val} onChange={(e) => setVal(e.target.value)}
                    className={isValid ? "input is-small" : "input is-small is-danger"}
                    type='number'
                    placeholder={label} onBlur={(e) => {
                        callback(val)
                    }} />
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please enter valid ${label}`}</p>}

        </div>

    )
}
export function AgPhone(props) {
    return (
        <div class="field has-addons">
            <p class="control">
                <input style={{ width: '4rem' }} class="input" type="text" placeholder=""
                    value={props.record['phonePrefix']} onChange={(e) => {
                        props.record['phonePrefix'] = e.target.value
                    }} />
            </p>
            <p class="control">
                <input class="input is-fullwidth" type="text" placeholder="Phone"
                    value={props.record['phone']} onChange={(e) => {
                        props.record['phone'] = e.target.value
                    }} />
            </p>
        </div>
    )
}
export function AgUnloc(props) {
    const { label, record, name, callback = f => f, isValid = true, validationMsg, isDisabled } = props
    const imRecord = useSnapshot(record)
    const [list, setList] = useState([])
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                <input autoComplete="off" {...props} name={name} value={imRecord[name] || ""} list={name}
                    {...isDisabled}
                    onChange={(e) => {
                        if (!e.nativeEvent.inputType) {
                            e.target.blur();
                          }
                        record[name] = e.target.value
                        Api.getMapUnloc({ descriptions: [e.target.value, record.shipmentType] }, (data) =>{
                            setList(data)
                            callback(e.target.value, data)
                        });   // TODO handle
                    }}
                    className={isValid || (name === 'reworkingPort' && !record[name]) ? "input is-small" : "input is-small is-danger"} />
                <datalist id={name}>
                    {
                        list.map((e, i) => <option key={i} value={e} />)
                    }
                </ datalist>
            </div>
            {(name === "reworkingPort" ? imRecord[name] && !isValid : !isValid) && (
            <p className="help is-danger">
                {validationMsg || `* Please select an UN location`}
            </p>
            )}
        </div>
    )
}
export function AgUnlocCH(props) {
    const { label, name, callback = f => f,callback2 = f => f, isValid = true, validationMsg, isDisabled,value,shipmentType } = props
    const [list, setList] = useState([])
    const [val, setVal] = useState(value)
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                <input autoComplete="off" {...props} name={name} defaultValue={value} list={name}
                    disabled={isDisabled}
                    onChange={(e) => {
                        if (!e.nativeEvent.inputType) {
                            e.target.blur();
                          }
                          setVal(e.target.value)
                          callback(e.target.value)
                        Api.getMapUnloc({ descriptions: [e.target.value, shipmentType] }, (data) =>{
                            setList(data)
                            callback2(e.target.value,data)
                        });   // TODO handle
                    }}
                    className={isValid ? "input is-small" : "input is-small is-danger"} />
                <datalist id={name}>
                    {
                        list.map((e, i) => <option key={i} value={e} />)
                    }
                </ datalist>
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please select an UN location`}</p>}
        </div>
    )
}
export function AgUnloc2(props) {
    const { label, record, name, callback = f => f, isValid = true, validationMsg, isDisabled } = props
    console.log("SC",record,name,label)
    const imRecord = useSnapshot(record)
    const [list, setList] = useState([])
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                <input autoComplete="off" {...props} name={name} value={imRecord[name]} list={name}
                    {...isDisabled}
                    onChange={(e) => {
                        if (!e.nativeEvent.inputType) {
                            e.target.blur();
                          }
                        record[name] = e.target.value
                        Api.getMapUnloc({ descriptions: [e.target.value, "LCL"] }, (data) =>{
                            setList(data)
                            callback(e.target.value, data)
                        });   // TODO handle
                    }}
                    className={isValid ? "input is-small" : "input is-small is-danger"} />
                <datalist id={name}>
                    {
                        list.map((e, i) => <option key={i} value={e} />)
                    }
                </ datalist>
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `* Please select an UN location`}</p>}
        </div>
    )
}
export function AgUnlocAll(props) {
    const { label, record, name, callback = f => f, isValid = true, validationMsg, isDisabled } = props
    
    const imRecord = useSnapshot(record)
    const [list, setList] = useState([])
    //console.log("SA",callback((d)=>{console.log(d)}))
    console.log("FV",isValid)
    console.log("FV",{...props})
   
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                <input autoComplete="off" {...props} name={name} value={imRecord[name]} list={name}
                    {...isDisabled}
                    onChange={(e) => {
                        if (!e.nativeEvent.inputType) {
                            e.target.blur();
                        }
                        record[name] = e.target.value
                        Api.getMapUnloc2({ descriptions: [e.target.value] }, (data) =>{
                            console.log("SDFsd",data)
                            setList(data)
                            callback(e.target.value, data)
                        });   // TODO handle
                    }}
                    className={isValid ? "input is-small" : "input is-small is-danger"} />
                <datalist id={name}>
                    {
                        list.map((e, i) => <option key={i} value={e} />)
                    }
                </ datalist>
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `- Please select an UN location`}</p>}
        </div>
    )
}
export function AgUnloc1(props) {
    let { label, record, name } = props
    const [list, setList] = useState([])
    const getUNCodeFromLocationString = (locString) => {
        if (locString.indexOf('(') != -1 && locString.indexOf(')') != -1) {
            return locString
                .trim()
                .slice(locString.lastIndexOf("(") + 1, locString.length - 1);
        } else {
            return locString.trim()
        }
    }

    function change() {
        for (let i = 0; i < record[name].length; i++) {
            let a = getUNCodeFromLocationString(record[name][i])
            if (a.length == 5) {
                if (record[`ts${i + 1}_port`] != a) {
                    record[`ts${i + 1}_port`] = a
                }
            } else {
                if (record[`ts${i + 1}_port`] != undefined) {
                    record[`ts${i + 1}_port`] = undefined
                }
            }
        }
    }

    function bing() {
        if (record[name].length < 3) {
            record[name].push("")
        }
    }

    function del(ind) {
        console.log(ind)
        let a = []
        for (let i = 0; i < record[name].length; i++) {
            if (i != ind) {
                a.push(record[name][i])
            }
        }
        for (let i = 0; i < a.length; i++) {
            record[`ts${i + 1}_port`] = a[i]
        }
        record[name] = a
        record[`ts${a.length + 1}_port`] = undefined
        change()
    }

    return (
        <div className="field">
            <div style={{ display: "flex" }}>
                <label className="label is-small" style={{ marginBottom: '0px' }}>{label} </label>
                {
                    (record && record[name].length < 3) ? <button style={{ position: 'relative', left: '18.35em', bottom: "0.5em" }} onClick={bing} className="button is-success is-inverted">
                        <span className="icon is-small">
                            <i className="fas fa-plus fas fa-lg"></i>
                        </span>
                    </button> : ""
                }

            </div>
            <div >
                {
                    (record[name]) ? record[name].map((e, i) => {
                        return <div className="control is-fullwidth" style={{ display: "flex" }}>
                            <input {...props} name={name} value={record[name][i]} list={i}
                                onChange={(e) => {
                                    record[name][i] = e.target.value
                                    change()
                                    Api.getMapUnloc({ descriptions: [e.target.value] }, setList)
                                }} style={{ width: "100%" }}
                            />
                            <datalist id={i}>
                                {
                                    list.map(e => <option value={e} />)
                                }
                            </ datalist>
                            {
                                (record && record[name][0].length != 0) ? <div className="field has-addons" >
                                    <p className="control">
                                        <button className="button is-success is-inverted" onClick={() => del(i)} style={{ position: "relative", bottom: "0.2em" }}>
                                            <span class="icon-text has-text-danger">
                                                <span class="icon">
                                                    <i class="fas fa-trash fas fa-lg"></i>
                                                </span>
                                            </span>
                                        </button>
                                    </p>
                                </div> : ""
                            }

                        </div>
                    }) : ""
                }

            </div>
        </div>
    )
}

export function TsUnloc(props) {
    let { label, record, name } = props
    const [list, setList] = useState([])
    const getUNCodeFromLocationString = (locString) => {
        console.log("<<<<", locString)
        if (locString.indexOf('(') != -1 && locString.indexOf(')') != -1) {
            return locString
                .trim()
                .slice(locString.lastIndexOf("(") + 1, locString.length - 1);
        } else {
            return locString.trim()
        }
    }
    // console.log(">>>>test", record.uploadShipmentType)
    return (
        <div className="field">
            <div className="columns">
                <div class="column is-half">
                    <label className="label is-small" style={{ marginBottom: '0px' }}>{label} </label>
                </div>
                <div class="column is-half">
                    <div className="control is-fullwidth" style={{ display: "flex" }}>
                        <input {...props} name={name} value={record[name]} list={name}
                            onChange={(e) => {
                                console.log("chec----------------->", e.target.value)
                                if (!e.nativeEvent.inputType) {
                                    e.target.blur();
                                  }
                                record[name] = getUNCodeFromLocationString(e.target.value)
                                console.log(e.target.value)
                                Api.getMapUnloc({ descriptions: [e.target.value, record.uploadShipmentType] }, setList)
                            }} style={{ width: "100%" }}
                        />
                        <datalist id={name} >
                            {
                                list.map(e => <option value={e} />)
                            }
                        </ datalist>


                    </div>

                </div>
            </div>
            {myactionsstore.isvalid && <div className="columns">
                <div class="column is-half"></div>
                <div class="column is-half">
                    <p class="help is-danger"> {`* Please enter valid unloc`}</p>
                </div>
            </div>}
        </div>
    )
}
export function AgUnlocdsr(props) {
    const { label, name, record, ...otherProps } = props
    if (record && record[name] == undefined) {
        record[name] = ""
    }
    const [list, setList] = useState([])
    const getUNCodeFromLocationString = (locString) => {
        if (locString.indexOf('(') != -1 && locString.indexOf(')') != -1) {
            return locString
                .trim()
                .slice(locString.lastIndexOf("(") + 1, locString.length - 1);
        } else {
            return locString.substring(0, 5).trim()
        }
    }
    return (
        <>
            <div className="columns">
                <div className="column is-6 py-2">
                    <div style={{ marginRight: '5px', marginTop: '3px', fontWeight: "bold" }}>{label}</div>
                </div>
                <div className="column is-6 py-2">
                    {(record) ? <input {...props} name={name} value={record[name]} list={name} style={{ width: "100%" }}
                        onChange={(e) => {
                            record[name] = getUNCodeFromLocationString(e.target.value)
                            Api.getMapUnloc({ descriptions: [e.target.value.toLowerCase()] }, setList)
                        }}
                    /> : <></>
                    }
                    <datalist id={name}>
                        {
                            list.map(e => <option value={e} />)
                        }
                    </ datalist>
                </div>
            </div>
        </>
    )
}


export function AgCommodity({ label, record, name, h }) {
    const imRecord = useSnapshot(record)
    let list = commodityList
    if (h === 'Yes') list = hazardousList
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                <input name={name} defaultValue={imRecord[name]} list='commodities'
                    onBlur={(e) => {
                        record[name] = e.target.value
                    }}
                    className="input is-small" />
                <datalist id='commodities'>
                    {
                        list.map(e => <option value={e} />)
                    }
                </ datalist>
            </div>
        </div>
    )
}
export function Email({ email, callback = f => f }) {
    return (
        <span className="tag is-link is-medium">
            {email}
            <button className="delete is-small" onClick={() => callback(email)}></button>
        </span>
    )
}
export function EmailListComp({ label, emailStore }) {
    useSnapshot(emailStore)
    const deleteEmail = (email) => {
        console.log(JSON.stringify(emailStore))
        let data = [...emailStore.emails]
        const index = data.findIndex(e => e === email)
        data.splice(index, 1)
        emailStore.emails = data
        console.log(JSON.stringify(emailStore))
    }
    let txtEmail = useRef()
    return (
        <div className="box">
            <div className="field has-addons">
                <div className="control">
                    <h6 class="title is-6" style={{ marginRight: '1rem' }}>{label}</h6>
                </div>
                <div className="control">
                    <input autoComplete="on" ref={txtEmail} onKeyUp={(e) => {
                        e.target.value = e.target.value.replace(/ /g, '')
                        // console.log(e.target.value)
                    }} name="email"
                        className="input is-small" type="email" placeholder="cust@mail.com" />
                </div>
                <div className="control">
                    <button className="button is-small is-success" onClick={
                        () => {
                            if (Utils.isEmail(txtEmail.current.value)) {
                                emailStore.emails.push(txtEmail.current.value)
                                txtEmail.current.value = ''
                            }
                        }}>
                        <span className="icon is-small">
                            <i className="fas fa-plus"></i>
                        </span>
                    </button>
                </div>
            </div>
            <div className="tags">
                {emailStore.emails.map(e => <Email email={e} callback={deleteEmail} />)}
            </div>
        </div>
    )
}
export function VanishMessage() {
    const imConfigStore = useSnapshot(configStore)
    setTimeout(() => {
        configStore.vanishingMessage = ''
    }, 1000)
    return <span style={{ color: 'red', fontSize: '14px' }}>{configStore.vanishingMessage}</span>
}

export function QuoteSavedMessage({ quotationRefNum }) {
    return (
        <>
            <section class="hero is-small has-text-centered">
                <div class="hero-body">
                    <p class="title">Quote Saved!</p>
                    <p class="subtitle">
                        <b>#</b> {quotationRefNum}
                        <br />
                        <br />
                        <button
                            class="button is-success"
                            //   style={{ textDecoration: "underline" }}
                            onClick={() => {
                                const modalBody = document.querySelector('.modal-card-body');
                                modalBody.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                });
                                Api.getQuote(quotationRefNum);
                                AgmodalStore.modalPage = "QuoteViewMainv3";
                                AgmodalStore.apiCall = false;
                                configStore.modalVisible = false;
                            }}
                        >
                            View Quotation
                        </button>
                    </p>
                </div>
            </section>
        </>
    );
}
export function QuoteSavedMessage1({ quotationRefNum }) {
    return (
        <>
            <section class="hero is-small has-text-centered">
                <div class="hero-body">
                    <p class="title">Quote Saved!</p>
                    <p class="subtitle">
                        <b>#</b> {quotationRefNum}
                        <br />
                        <br />
                    </p>
                </div>
            </section>
        </>
    );
}
export function PricingQuoteSaved({ quotationRefNum }) {
    return (
        <>
            <section class="hero is-small has-text-centered">
                <div class="hero-body">
                    <p class="title">Quote Saved!</p>
                    <p class="subtitle">
                        <b>#</b> {quotationRefNum}
                        <br />
                    </p>
                    <p>You can now Edit the quote using the Quotation tool</p>
                </div>
            </section>
        </>
    );
}
export function PricingContractSaved({ contractNum }) {
    return (
        <>
            <section class="hero is-small has-text-centered">
                <div class="hero-body">
                    <p class="title">Contract Created!</p>
                    <p class="subtitle">
                        <b>#</b> {contractNum}
                        <br />
                        <br />
                    </p>
                    <p>You can now place bookings against this Contract from the Bookings page</p>
                </div>
            </section>
        </>
    );
}

export function TableEditaca(props) {
    useSnapshot(configStore)
    const { record, name, type = 'text', tabIndex , isreadonly = false, callback = f => f, isValid = true, isDisabled } = props
    const imRecord = useSnapshot(record)
    const [v,setV] = useState("")
    const inputRef = useRef(null);
    if(record[name]!=undefined && v!=record[name] && v.length==0){
        setV(record[name])
    }
    const handleInputChange = (e) => {
        if(configStore.acafoucs!=tabIndex+name){
            configStore.acafoucs = tabIndex+name
        }
        const newValue = e.target.value
        record[name] = newValue; // Update the Valtio state
        callback(newValue);
    };
    useEffect(()=>{
        if(configStore.acafoucs==tabIndex+name){
            if(inputRef){
                inputRef.current.focus()
            }
        }
    },[inputRef.current])
    return (
        <div className="control is-fullwidth is-small" onBlur={() => {
    if (configStore.acafoucs === tabIndex + name) {
      configStore.acafoucs = null;
       }
  }} onClick={()=>{
            if(configStore.acafoucs!=tabIndex+name){
                configStore.acafoucs = tabIndex+name
            }
        }}>
            <input
            id={tabIndex+name}
            ref={inputRef}
                style={{ color: 'black' }}
                {...props}
                type={type}
                name={name}
                value={v}
                onClick={(e) =>{
                    if(configStore.acafoucs!=tabIndex+name){
                        configStore.acafoucs = tabIndex+name
                    }
                }
                }
                onChange={handleInputChange}
                // onChange={(e)=>{
                //     console.log("a",v,e.target.value)
                //     setV(e.target.value)
                //     console.log("b",v,e.target.value)
                // }}
                // value={imRecord[name]}
                className={isValid ? "input is-small" : "input is-small is-danger"}
                inputmode={type}
                {...isDisabled}
                readOnly={isreadonly}
            />
        </div>
    )
}

export function EditableInputaca(props) {
    useSnapshot(configStore)
    const { record, name, type = 'text', tabIndex , isreadonly = false, callback = f => f, isValid = true, isDisabled } = props
    const imRecord = useSnapshot(record)
    const [value, setValue] = useState(imRecord[name] || '');
    const inputRef = useRef(null);
    useEffect(() => {
        setValue(imRecord[name] || ''); 
    }, [imRecord, name]);
    useEffect(()=>{
        if(configStore.acafoucs==tabIndex+name){
            if(inputRef){
                inputRef.current.focus()
            }
        }
    },[inputRef.current])

    const handleInputChange = (e) => {
        if(configStore.acafoucs!=tabIndex+name){
            configStore.acafoucs = tabIndex+name
        }
        setValue(e.target.value);
    };

    const handleBlur = () => {
        record[name] = value;
        callback(value);
    };

    return (
        <div className="control is-fullwidth is-small" onClick={()=>{
            if(configStore.acafoucs!=tabIndex+name){
                configStore.acafoucs = tabIndex+name
            }
        }}>
            <input
            id={tabIndex+name}
            ref={inputRef}
            onClick={()=>{
                if(configStore.acafoucs!=tabIndex+name){
                    configStore.acafoucs = tabIndex+name
                }
            }}
                type="text"
                value={value}
                onChange={handleInputChange}
                onBlur={handleBlur}
                {...isDisabled}
                className={`input is-small ${isValid ? '' : 'is-danger'}`}
            />
        </div>
    );
}

export function TableEditChargesaca(props) {
    useSnapshot(configStore)
    const { record, name, type,tabIndex, isreadonly = false, callback = f => f, isValid = true, isDisabled } = props;
    const imRecord = useSnapshot(record);
    const [val, setVal] = useState(imRecord[name] || ''); // Initialize with the value from imRecord if available
    const inputRef = useRef(null);
    useEffect(() => {
        setVal(imRecord[name] || ''); 
    }, [imRecord, name]);
    useEffect(()=>{
        if(configStore.acafoucs==tabIndex+name){
            if(inputRef){
                inputRef.current.focus()
            }
        }
    },[inputRef.current])

    const handleInputChange = (e) => {
        if(configStore.acafoucs!=tabIndex+name){
            configStore.acafoucs = tabIndex+name
        }
        setVal(e.target.value);
    };

    const handleBlur = () => {
        record[name] = val;
    };

    return (
        <div className="control is-fullwidth is-small" onClick={()=>{
            if(configStore.acafoucs!=tabIndex+name){
                configStore.acafoucs = tabIndex+name
            }
        }}>
            <input
            id={tabIndex+name}
            ref={inputRef}
            onClick={()=>{
                if(configStore.acafoucs!=tabIndex+name){
                    configStore.acafoucs = tabIndex+name
                }
            }}
                style={{ color: 'black' }}
                {...props}
                type={type}
                {...props}
                name={tabIndex+name}
                value={val}
                onChange={handleInputChange}
                onBlur={handleBlur}
                className={isValid ? "input is-small" : "input is-small is-danger"}
                {...isDisabled}
                readOnly={isreadonly}
            />
        </div>
    );
}
export function TableSelectaca(props) {
    useSnapshot(configStore)
    const inputRef = useRef(null);
    const { record, name, dataList, tabIndex , callback = f => f, isValid = true, isDisabled } = props
    const imRecord = useSnapshot(record)
    let isonaccountvalid = true
    if(name == "currency" && record[name] != undefined && record[name].trim().length>0){
        let a = configStore.getExchangeRate(record[name])
        if(record["currencyinr"] != a){
            record["currencyinr"] = a
        }
    }
    if(name=="onaccount" && isValid==false){
        isonaccountvalid = true
    }else{
        isonaccountvalid = isValid
    }
    if(name === 'onaccount' && (record[name] === undefined || record[name].trim().length==0)){
        record[name] = 'On Your Account'
    }
    if(name === 'onaccount' && !dataList.includes(record[name])){
        record[name] = ""
    }
    useEffect(()=>{
        if(configStore.acafoucs==tabIndex+name){
            if(inputRef){
                inputRef.current.focus()
            }
        }
    },[inputRef.current])

    //console.log("props-------------->",props,record[name])
    // const packageTypeList = ['', 'Pallet', 'Drum', 'Crate', 'Skid', 'Loose Cartons', 'Box', 'Bales', 'Rolls']
    return (
        <div className={isValid || isonaccountvalid ? "select is-small" : "select is-small is-danger"} onBlur={()=>{
            if(configStore.acafoucs!=tabIndex+name){
                configStore.acafoucs = null
            }
        }} onClick={()=>{
            if(configStore.acafoucs!=tabIndex+name){
                configStore.acafoucs = tabIndex+name
            }
        }}>
            <select id={tabIndex+name} style={{ color: 'black' }} {...props} tabIndex={tabIndex} name={name}
            ref={inputRef}
            onBlur={()=>{
                configStore.acafoucs = null
            }}
            onClick={()=>{
                if(configStore.acafoucs!=tabIndex+name){
                    configStore.acafoucs = tabIndex+name
                }
            }}
                value={imRecord[name]} onChange={(e) => {
                    if(configStore.acafoucs!=tabIndex+name){
                        configStore.acafoucs = tabIndex+name
                    }
                    record[name] = e.target.value
                    if(name === 'containerType'){
                        fclChargesStore.defaultValueCalc() // Need to calculate for validation
                    }
                    callback(e.target.value)
                }}
                {...isDisabled}>
                <option selected={!isDisabled} value={''} hidden>
                    {''}
                </option>
                {dataList.filter(val => val !== '').map(val => <option selected={val === record[name]} key={val}>{val}</option>)}
            </select>
        </div>
    )
}

export function AgUnlocall1(props) {
    const { label, record, name, callback = f => f, isValid = true, validationMsg, isDisabled } = props
    
    const imRecord = useSnapshot(record)
    const [list, setList] = useState([])
    //console.log("SA",callback((d)=>{console.log(d)}))
    console.log("FV",isValid)
    console.log("FV",{...props})
   
    return (
        <div className="field">
            <label className="label is-small" style={{ marginBottom: '0px' }}>{label}</label>
            <div className="control is-fullwidth">
                <textarea rows={3} autoComplete="off" {...props} name={name} value={imRecord[name]} list={name}
                    {...isDisabled}
                    onChange={(e) => {
                        if (!e.nativeEvent.inputType) {
                            e.target.blur();
                        }
                        record[name] = e.target.value
                        Api.getMapUnloc2({ descriptions: [e.target.value] }, (data) =>{
                            console.log("SDFsd",data)
                            setList(data)
                            callback(e.target.value, data)
                        });   // TODO handle
                    }}
                    className={isValid ? "input is-small" : "input is-small is-danger"} />
                <datalist id={name}>
                    {
                        list.map((e, i) => <option key={i} value={e} />)
                    }
                </ datalist>
            </div>
            {!isValid && <p class="help is-danger"> {validationMsg || `- Please select an UN location`}</p>}
        </div>
    )
}

export function AgTextareaInput(props) {
  const {
    label,
    record,
    name,
    isValid = true,
    validationMsg,
    isDisabled = false,
    placeholder,
    rows = 3,
    minHeight = '10px'
  } = props;

  const imRecord = useSnapshot(record);

  return (
    <div className="field">
      <label className="label is-small" style={{ marginBottom: '0px' }}>
        {label}
      </label>
      <div className="control is-fullwidth">
        <textarea
          id={name}
          name={name}
          value={imRecord[name]}
          placeholder={placeholder || label}
          rows={rows}
          style={{ minHeight, resize: 'vertical' }}
          className={isValid ? 'textarea is-small' : 'textarea is-small is-danger'}
          disabled={isDisabled}
          onChange={(e) => {
            record[name] = e.target.value;
          }}
        />
      </div>
      {!isValid && (
        <p className="help is-danger">
          {validationMsg || `* Please enter valid ${label}`}
        </p>
      )}
    </div>
  );
}